import React from "react"
import { Input, Button, Table, Space, Form } from 'antd'
import { FormInstance } from "antd/lib/form"
import Modal from "antd/lib/modal/Modal"
import axios, { axiosTable } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,
    type: string | null,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    item: any,
    fetchOtherParams: {
        reason_desc: string | null
    },
    formParams: {
        item_type: string | null
    },
    addVisible: false
}

export default class CkOrderList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        type: 'add',
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        item: {
            reason_desc: null,
        },
        fetchOtherParams: {
            reason_desc: null
        },
        formParams: {
            item_type: null
        },
        addVisible: false
    }

    formRef = React.createRef<FormInstance>()

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/markting_center/no_effective_reason/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state

                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    reviewDetail(item: object | any) {
        axiosTable.get("/markting_center/no_effective_reason/detail", { params: { id: item.id } }).then((res: any) => {
            item = res;
        }).then(() => {
            this.setState({
                item,
                type: 'edit',
                addVisible: true
            })
            this.setState({ addVisible: true }, () => {
                for (let i in this.state.item) {
                    this.formRef.current?.setFieldsValue({ [i]: item[i] })
                }
            })
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;
        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    confirmAdd(value: any) {
        let { item } = this.state;
        let url: string = ''

        if (item.id) {
            url = '/markting_center/no_effective_reason/update'
            value.id = item.id;

        } else {
            url = '/markting_center/no_effective_reason/add'
        }

        axios.post(url, value).then(() => {
            const { pagination, fetchOtherParams } = this.state

            this.fetch({ pagination, fetchOtherParams })
            this.closeModal()
        })
    }

    closeModal() {
        let { item } = this.state;
        for (let i in item) {
            this.formRef.current?.setFieldsValue({ [i]: '' })
        }

        this.setState({
            addVisible: false,
            item
        })
    }

    delItem(id: string) {
        axios.post('/markting_center/no_effective_reason/delete', { id: id }).then((response: any) => {
            this.selectState('current')
        })
    }

    render() {
        let { reason_desc } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 营销中心 -> 营销配置 -> 失效原因配置 */}
            <BreadCrumb position={['营销中心', '失效原因配置']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => { this.setState({ addVisible: true, type: 'add' }) }}>添加</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={this.state.pagination} onChange={this.handleTableChange.bind(this)}>
                    <Column title="失效原因" dataIndex="reason_desc" key="reason_desc" />
                    {/* <Column
                        title="更新人"
                        key="action"
                        render={(text, record: any) => (
                            record.update_user_name ? <div>{record.update_user_name}</div> : <div>{record.create_user_name}</div>
                        )}
                    /> */}
                    <Column
                        title="更新时间"
                        key="action"
                        render={(text, record: any) => (
                            record.update_time ? <div>{record.update_time}</div> : <div>{record.create_time}</div>
                        )}
                    />

                    {/* <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Button type="primary" onClick={this.reviewDetail.bind(this, record)}>编辑</Button>
                                <Button type="primary" danger onClick={this.delItem.bind(this, record.id)}>删除</Button>
                            </Space>
                        )}
                    /> */}
                </Table>
            </div>

            {/* 新增或编辑 */}
            <Modal title={(this.state.type == 'edit' ? "编辑" : "新增") + '失效原因'} visible={this.state.addVisible} footer={false} width="400px" onCancel={this.closeModal.bind(this)}>
                <Form name="validate_other" ref={this.formRef} {...formItemLayout} onFinish={this.confirmAdd.bind(this)} >
                    <Form.Item label="失效原因" name="reason_desc" rules={[{ required: true, message: '必须填写失效原因' }]}>
                        <Input placeholder="失效原因" />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}